import axios, { AxiosError } from 'axios';
import { EGerdauService } from '../EGerdauService';

export const refreshAuthTokenApi = axios.create({
  baseURL: process.env.REACT_APP_REFRESH_AUTH_TOKEN
    ? process.env.REACT_APP_REFRESH_AUTH_TOKEN
    : ''
});

refreshAuthTokenApi.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error: AxiosError) => {
    EGerdauService.treatAxiosError(error);
    return Promise.reject(error);
  }
);

export enum ERefreshTokenEndpoints {
  REFRESH_TOKEN = '/token'
}
